export const HEARTBEAT_INTERVAL = 10000;
